<template>
    <div>
        <TitlePage :title="$t('PromoSuperAdminGlobal')"></TitlePage>
        <v-container fluid>
            <div class="dashboard-page">
                <v-row>
                    <v-col cols="12" md="12">
                        <v-card elevation="2">
                            <v-card>
                                <template v-if="!plus">
                                    <v-card-title>
                                        <v-text-field v-model="search" append-icon="mdi-magnify"
                                                      label="Cerca nella tabella..." single-line hide-details dense/>
                                    </v-card-title>
                                    <v-data-table :headers="headers" :items="items" :search="search" sort-by="center_name"
                                                  :items-per-page="50">
                                        <template v-slot:body="{ items }">
                                            <tbody>
                                                <template v-for="item in items">
                                                    <tr>
                                                        <td style="cursor: pointer" @click="plus = item">
                                                            <strong>{{ item.center_name }}</strong>
                                                        </td>
                                                        <td>
                                                            {{ item.center_fields.length }}
                                                        </td>
                                                        <td>
                                                            <v-switch
                                                                class="mt-0"
                                                                dense
                                                                v-model="item.promo_sa_global.active"
                                                                inset
                                                                :color="(item.promo_sa_global.active)?'green':'grey'"
                                                                hide-details
                                                                @change="updateCenter(item)"
                                                            ></v-switch>
                                                        </td>
                                                        <td style="cursor: pointer">
                                                            <div @click="plus = item" v-if="item.promo_sa_global.active">
                                                                <v-icon>mdi-plus</v-icon>
                                                                Impostazioni
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </template>
                                    </v-data-table>
                                </template>
                                <template v-else>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col cols="12" class="mt-0 mb-0 pb-0">
                                                <p>Impostazioni globali per tutte le promo super admin del Centro Sportivo</p>
                                                <ul style="font-size: 13px">
                                                    <li><strong>N° Vendite MAX</strong>:
                                                        Indicare il numero di vendite massime della Promo SA nell'intervallo di tempo settato nel valore
                                                        N° GG MAX Cont. vendite
                                                    </li>
                                                    <li><strong>N° GG MAX Conteggio vendite</strong>:
                                                        Indicare il numero di giorni MAX nel quale deve essere rispettato N° Vendite MAX
                                                    </li>
                                                    <li><strong>Vendita Senza Limitazioni</strong>:
                                                        Se abilitata, permette la vendita della Promo SA anche sullo stesso campo.<br/>
                                                        Se disabilitata, su un campo che ha già venduto almeno 1 Promo SA non sarà più possibile
                                                        venderne altre
                                                    </li>
                                                  <li><strong>Prox. attivazione</strong>:
                                                      La data da cui parte il conteggio dei giorni per l'attivazione della Promo SA.
                                                      E' calcolata in automatico dal sistema, ma può essere utile in caso di override per ripartire da una data precisa.
                                                  </li>
                                                </ul>
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <div class="pa-2 font-weight-bold box-color-primary">N° Vendite MAX</div>
                                            </v-col>
                                            <v-col cols="12" md="1" class="align-flex-center">
                                                <v-text-field class="mt-0 pt-0" type="number" v-model="plus.promo_sa_global.max_promo_count" step="1"
                                                              min="0" max="100" />
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <div class="pa-2 font-weight-bold box-color-primary">N° GG MAX Cont. vendite</div>
                                            </v-col>
                                            <v-col cols="12" md="1" class="align-flex-center">
                                                <v-text-field class="mt-0 pt-0" type="number" v-model="plus.promo_sa_global.max_promo_days" step="1"
                                                              min="0" max="100" />
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <div class="pa-2 font-weight-bold box-color-primary">Senza Limitazioni</div>
                                            </v-col>
                                            <v-col cols="12" md="1" class="align-flex-center mt-0 pt-0">
                                                <v-checkbox
                                                    v-model="plus.promo_sa_global.allow_resell"
                                                    color="success"
                                                    hide-details
                                                    class="mt-0 pt-0"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="1">
                                              <div class="pa-2 font-weight-bold box-color-primary">Prox. attivazione</div>
                                            </v-col>
                                            <v-col cols="12" md="2" class="align-flex-center mt-0 pt-0">
                                              <v-menu
                                                  v-model="menu_date_next_promo" :close-on-content-click="false"
                                                  transition="scale-transition" offset-y max-width="290px" min-width="auto"
                                              >
                                                <template v-slot:activator="{ on, attrs }">
                                                  <v-text-field v-model="formatDateNextPromo" @click:clear="plus.promo_sa_global.next_promo_date = null"
                                                                readonly v-bind="attrs" v-on="on" hide-details class="mt-0 pt-0"/>
                                                </template>
                                                <v-date-picker :first-day-of-week="1" v-model="plus.promo_sa_global.next_promo_date" no-title @input="menu_date_next_promo = false"/>
                                              </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="12" >
                                                <v-btn elevation="2" color="primary" class="ml-auto" @click="updateCenter(plus)" type="submit">
                                                    {{ $t('save') }}
                                                    <v-icon right>mdi-content-save</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left header-table">
                                                    Centro Sportivo
                                                </th>
                                                <th class="text-left header-table">
                                                    Campo
                                                </th>
                                                <th class="text-left header-table">
                                                    Promo Attiva
                                                </th>
                                                <th class="text-left header-table">
                                                    Sport
                                                </th>
                                                <th class="text-left header-table">
                                                    Azioni
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="field in plus.center_fields" :key="field._id">
                                                <td><strong>{{ plus.center_name }}</strong></td>
                                                <td><strong>{{ field.name }}</strong></td>
                                                <td>
                                                    <v-switch
                                                        class="mt-0"
                                                        dense
                                                        inset
                                                        v-model="field.promo_sa_global.active"
                                                        :color="(field.promo_sa_global.active)?'green':'grey'"
                                                        hide-details
                                                        @change="updatePromoSaGlobal(field)"
                                                    ></v-switch>
                                                </td>
                                                <td>
                                                    <template v-for="(sport,i) in field.sports_info">
                                                        {{sport.name}}<span v-if="i<field.sports_info.length-1">,</span>
                                                    </template>
                                                </td>
                                                <td style="cursor: pointer">
                                                    <template v-if="field.promo_sa_global.active" >
                                                        <div @click="edit(field.promo_sa_global._id)">Impostazioni</div>
                                                    </template>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-flex md12 class="pa-5 d-flex buttons-group-mobile">
                                        <v-btn elevation="2" color="" class="mr-auto" @click="plus = null">
                                            <v-icon left>mdi-keyboard-backspace</v-icon>
                                            {{ $t('back') }}
                                        </v-btn>
                                    </v-flex>
                                </template>
                            </v-card>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import {mapActions, mapMutations} from "vuex";

export default {
    name: "PromoSuperAdminGlobal",
    components: {TitlePage, CenterAutocomplete},
    data() {
        return {
            pathEdit: '/promo-sa-global/edit/',
            search: '',
            items: [],
            headers: [
                {text: 'Centro Sportivo', align: 'start', value: 'center_name', class:'header-table'},
                {text: 'N° Campi', align: 'start', value: 'fields_num', class:'header-table', sortable: false, searchable: false},
                {text: 'Promo Attiva', value: 'promo_sa_global_active', sortable: false, searchable: false, class:'header-table'},
                {text: 'Azioni', align: 'start', value: 'actions', sortable: false, searchable: false, class:'header-table'},
            ],
            plus: null,
            menu_date_next_promo: false,
        };
    },
    methods: {
        ...mapMutations({
            'setLoading': 'settings/setLoading',
            'setNotification': 'settings/setNotification',
        }),

        ...mapActions({
            'getItems': 'promoSAGlobal/index',
            'updateCenterItem':'centers/update',
            'storeItem':'promoSAGlobal/store',
            'updateItem':'promoSAGlobal/update',
        }),

        async makeSearch() {
            this.setLoading(true);
            this.items = await this.getItems();
            this.setLoading(false)
        },

        async updateCenter(item){

            await this.setLoading(true);
            let result = await this.updateCenterItem({id:item.center_id, item:{promo_sa_global:item.promo_sa_global}})
            await this.setLoading(false);

            if(result.success){

                this.setNotification({
                    active: true,
                    color: 'success',
                    mode: 'multi-line',
                    text: this.$t('updateSuccess')
                })

            }else {

                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: result
                })

            }

        },

        async updatePromoSaGlobal(field){
            let result
            let store
            await this.setLoading(true);
            if(field.promo_sa_global._id){
                result = await this.updateItem({id:field.promo_sa_global._id, item:{active:field.promo_sa_global.active}})
            }else{
                store = true
                result = await this.storeItem({center_id:this.plus.center_id, field_id: field._id, active: true})
            }

            await this.setLoading(false);

            if(result.success){

                if(store){
                    field.promo_sa_global = {
                        _id: result.result.result._id,
                        active: true
                    }
                }

                this.setNotification({
                    active: true,
                    color: 'success',
                    mode: 'multi-line',
                    text: this.$t('updateSuccess')
                })

            }else {

                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: result
                })

            }

        },

        edit(id){
            this.$router.push(this.pathEdit+id)
        },

      formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        let day_fixed = (day.includes('T')) ? day.split('T')[0] : day
        return `${day_fixed}/${month}/${year}`
      },

    },
    mounted() {
    },
    computed: {
      formatDateNextPromo() {
        return this.formatDate(this.plus.promo_sa_global.next_promo_date)
      },
    },
    async created() {
        this.setLoading(true);
        await this.makeSearch()
        if(this.$route.query.center_id){
          this.plus = this.items.find(c => String(c.center_id) === this.$route.query.center_id)
        }
        this.setLoading(false);
    },


}
</script>

<style>

.header-table{
    background: #222b54;
    color: white !important;
}
.header-table i{
    color: white !important;
}

 .box-color-primary {
     background: #222b54;
     color: white;
     border-radius: 3px;
     font-size: 12px;
 }

.align-flex-center{
    align-items: center;
    display: flex;
}

.v-data-table--mobile > .v-data-table__wrapper tbody {
  display: contents;
}

</style>